import AdministratorStudentRelations from "./01.StudentRelations/Student.Administrator";
import SuperAgentStudentRelations from "./01.StudentRelations/Student.SuperAgent";
import CompanyStudentRelations from "./01.StudentRelations/Student.Company";
import StudentInformation from "./02.StudentInformation";
import StudentLocation from "./03.StudentLocation";
import StudentTiming from "./04.StudentTiming";

const Component = {
  AdministratorStudentRelations,
  SuperAgentStudentRelations,
  CompanyStudentRelations,
  StudentInformation,
  StudentLocation,
  StudentTiming,
};

export default Component;
